import { twMerge } from 'tailwind-merge';
import React, { ButtonHTMLAttributes, forwardRef } from 'react';
import { useRowTabIndex } from './row-tab-stop';

type Props = ButtonHTMLAttributes<HTMLButtonElement>;

// `focus-ring` (tailwind.plugin.css) is the keyboard focus indicator for
// every button built on this one. In a list row that does not hold the
// list's Tab stop, the button is out of the Tab order. The ref reaches the
// <button>, for a caller that moves focus to it.
const BaseButton = forwardRef<HTMLButtonElement, Props>(function BaseButton(
    { className, children, tabIndex, ...props },
    ref,
) {
    const rowTabIndex = useRowTabIndex();

    return (
        <button
            ref={ref}
            className={twMerge(
                'focus-ring flex items-center justify-center rounded-sm p-1 disabled:bg-gray-300 disabled:text-gray-500',
                className,
            )}
            tabIndex={rowTabIndex ?? tabIndex}
            {...props}
        >
            {children}
        </button>
    );
});

export default BaseButton;
